import React from 'react';
import { FiX } from 'react-icons/fi';

interface RoleChangeConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName: string;
  currentRole: string;
  newRole: string;
  isLoading?: boolean;
}

export default function RoleChangeConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  userName,
  currentRole,
  newRole,
  isLoading = false
}: RoleChangeConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-[#2A2A2A] rounded-lg w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
          disabled={isLoading}
        >
          <FiX size={20} />
        </button>

        <h2 className="text-xl font-semibold text-white mb-4">Confirm Role Change</h2>

        <div className="space-y-4 mb-6">
          <p className="text-gray-300">
            Are you sure you want to change the role for <span className="text-white font-semibold">{userName}</span>?
          </p>
          
          <div className="bg-[#1A1A1A] rounded-md p-4 space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-gray-400">Current Role:</span>
              <span className="text-white font-medium">{currentRole}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-400">New Role:</span>
              <span className="text-green-400 font-medium capitalize">{newRole}</span>
            </div>
          </div>
        </div>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                <span>Updating...</span>
              </>
            ) : (
              'Yes, Change Role'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
